import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-platform-project-management.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Manage More Projects";

const MainHero = () => (
  <HeroSection title={title} className="flex-col md:flex-row">
    <HeroSection.Content className="py-4 md:py-8 md:w-1/2 xl:w-2/5">
      <HeroSection.Header className="md:items-start">
        <Heading tag="h1">{title}</Heading>
      </HeroSection.Header>
      <HeroSection.Description>
        Enerflo’s project management features <span className="whitespace-nowrap">(AKA Install Tracker)</span> can be
        used out of the box or integrate with your favorite CRM to improve your installation workflows and take control
        of your projects.
      </HeroSection.Description>
    </HeroSection.Content>

    <figure className="p-3 w-full xs:w-3/4 md:w-1/2 xl:w-3/5">
      <Image
        src={FigureImage}
        alt="Use Enerflo Project Management features out of the box or integrate with your favorite CRM to power your project management data."
        layout="responsive"
        quality={100}
        priority
        placeholder="blur"
        loading="eager"
        className="crispImage"
        sizes="(min-width: 768px) 60vw, 100vw"
        lazyBoundary="400px"
      />
    </figure>
  </HeroSection>
);

export default MainHero;
